import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import { Layout } from './components/Layout/Layout'
import { Dashboard } from './pages/Dashboard/Dashboard'
import { CertificationJourney } from './pages/CertificationJourney/CertificationJourney'
import { Enablement } from './pages/Enablement/Enablement'
import { Implementation } from './pages/Implementation/Implementation'
import { Support } from './pages/Support/Support'
import { MSSP } from './pages/MSSP/MSSP'
import { ASD } from './pages/ASD/ASD'
import { Admin } from './pages/Admin/Admin'
import { ChatWidget } from './components/Chat/ChatWidget'

function App() {
  const { isAuthenticated, partner } = useAuthStore()
  console.log('App render:', { isAuthenticated, partner: !!partner })

  // If no partner loaded yet, let Layout handle the loading state
  if (!partner) {
    return (
      <div className="min-h-screen bg-background">
        <Routes>
          <Route path="*" element={<Layout />} />
        </Routes>
        <ChatWidget />
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-background">
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="certifications/*" element={<CertificationJourney />} />
          <Route path="enablement" element={<Enablement />} />
          <Route path="implementation" element={<Implementation />} />
          <Route path="support" element={<Support />} />
          <Route path="mssp" element={<MSSP />} />
          <Route path="asd" element={<ASD />} />
          <Route path="admin/*" element={<Admin />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
      <ChatWidget />
    </div>
  )
}

export default App
